import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { IntegrityMonitorRulesAppGzDataProvider } from '../dataProvider/IntegrityMonitorRulesAppGzDataProvider';

export class IntegrityMonitorRulesAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorRulesAppGzDataProvider);
  }
}
